export default __webpack_public_path__ + "static/media/securityCode.e9f0df1a.png";